module.exports = __webpack_public_path__ + "media/images/horizontal_barcode-3fae3082f3c4ba72589068f6be75e02d.png";